import { FolderId } from 'modules/domains/foldering';

export const isFolderValidDestination = (
  destinationFolderId: FolderId,
  folderIdsToMove: FolderId[],
) => {
  // a folder cannot be moved into itself
  if (folderIdsToMove.includes(destinationFolderId)) {
    return false;
  }

  return true;
};
